import React, { useState, useEffect } from 'react';
import { AlertTriangle, CheckCircle, Clock, XCircle } from 'lucide-react';
import { apiService } from '../services/apiService';
import { format } from 'date-fns';

function AlarmasPanel({ plantaId }) {
  const [alarmas, setAlarmas] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadAlarmas();
    const interval = setInterval(loadAlarmas, 10000);
    return () => clearInterval(interval);
  }, [plantaId]);

  const loadAlarmas = async () => {
    try {
      const data = await apiService.getAlarmas();
      setAlarmas(data);
    } catch (error) {
      console.error('Error cargando alarmas:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleReconocer = async (alarmaId) => {
    try {
      await apiService.reconocerAlarma(alarmaId, 'Operador');
      loadAlarmas();
    } catch (error) {
      console.error('Error reconociendo alarma:', error);
    }
  };

  const getSeverityColor = (severidad) => {
    const colors = {
      critical: 'bg-red-100 text-red-800 border-red-300',
      error: 'bg-orange-100 text-orange-800 border-orange-300',
      warning: 'bg-yellow-100 text-yellow-800 border-yellow-300',
      info: 'bg-blue-100 text-blue-800 border-blue-300'
    };
    return colors[severidad] || colors.info;
  };

  const getSeverityIcon = (severidad) => {
    if (severidad === 'critical' || severidad === 'error') {
      return <XCircle className="w-5 h-5" />;
    }
    return <AlertTriangle className="w-5 h-5" />;
  };

  if (loading) {
    return <div className="card">Cargando alarmas...</div>;
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold text-gray-900">Alarmas Activas</h2>
        <div className="badge badge-error">
          {alarmas.length} alarma{alarmas.length !== 1 ? 's' : ''}
        </div>
      </div>

      {alarmas.length === 0 ? (
        <div className="card text-center py-12">
          <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-4" />
          <h3 className="text-xl font-semibold text-gray-900 mb-2">
            Sin Alarmas Activas
          </h3>
          <p className="text-gray-600">
            Todos los sistemas operando normalmente
          </p>
        </div>
      ) : (
        <div className="space-y-3">
          {alarmas.map((alarma) => (
            <div 
              key={alarma.id}
              className={`card border-l-4 ${getSeverityColor(alarma.severidad)}`}
            >
              <div className="flex items-start justify-between">
                <div className="flex items-start space-x-3 flex-1">
                  <div className="mt-1">
                    {getSeverityIcon(alarma.severidad)}
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center space-x-2 mb-1">
                      <h3 className="font-semibold text-gray-900">
                        {alarma.codigo || 'ALARMA'}
                      </h3>
                      <span className={`badge ${getSeverityColor(alarma.severidad)}`}>
                        {alarma.severidad}
                      </span>
                    </div>
                    <p className="text-gray-700 mb-2">{alarma.mensaje}</p>
                    <div className="flex items-center space-x-4 text-sm text-gray-600">
                      <span className="flex items-center">
                        <Clock className="w-4 h-4 mr-1" />
                        {format(new Date(alarma.timestamp), 'dd/MM/yyyy HH:mm:ss')}
                      </span>
                      {alarma.equipo_id && (
                        <span>Equipo: {alarma.equipo_id}</span>
                      )}
                      {alarma.valor_actual && (
                        <span>Valor: {alarma.valor_actual}</span>
                      )}
                    </div>
                  </div>
                </div>
                
                {!alarma.reconocida && (
                  <button
                    onClick={() => handleReconocer(alarma.id)}
                    className="btn btn-primary ml-4"
                  >
                    Reconocer
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default AlarmasPanel;
